import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App/index';
import * as serviceWorker from './serviceWorker';
import mainReducer from './store/mainReducer';
import { configureStore } from '@reduxjs/toolkit';
import * as immutableState from 'redux-immutable-state-invariant'
import thunk from 'redux-thunk';
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from "react-query";

const reduxImmutableMiddleWare = immutableState.default();
const store = configureStore({reducer: mainReducer, middleware: [reduxImmutableMiddleWare, thunk] });
const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter basename={window.configs.dashboard_base_path}>
      <QueryClientProvider client={new QueryClient()}>
        <App />
      </QueryClientProvider>
    </BrowserRouter>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
